import { render, staticRenderFns } from "./ActiveWidgetMenu.vue?vue&type=template&id=7373f7ec&scoped=true&"
import script from "./ActiveWidgetMenu.vue?vue&type=script&lang=js&"
export * from "./ActiveWidgetMenu.vue?vue&type=script&lang=js&"
import style0 from "./ActiveWidgetMenu.vue?vue&type=style&index=0&id=7373f7ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7373f7ec",
  null
  
)

export default component.exports